<label class="section-label heading2">Summary - By Product</label>
<ng-container *ngIf="data$ | async as data; else empty">
  <ng-container *ngIf="totals$ | async as totals">
    <table mdbTable *ngIf="data.length != 0">
      <thead>
        <tr>
          <th class="table_heading1">
            Product
          </th>
          <th class="table_heading1">
            Units
          </th>
          <th class="table_heading1 no_mobile">
            Avg Price
          </th>
          <th class="table_heading1">
            Sub Total
          </th>
          <th class="table_heading1 no_mobile">
            Service Fees
          </th>
          <th class="table_heading1">
            Tips
          </th>
          <th class="table_heading1 no_mobile">
            Tip %
          </th>
          <th class="table_heading1">
            Total
          </th>
          <th class="table_heading1 no_mobile">
            # Redeemed
          </th>
          <th class="table_heading1">
            Redeemed
          </th>
          <th class="table_heading1 no_mobile">
            % Revenue
          </th>
        </tr>
      </thead>
      <tbody class="body1" *ngIf="data.length != 0">
        <tr class="hoverable" *ngFor="let element of data">
          <td>{{ mask(element.key) }}</td>
          <td>{{ element.units }}</td>
          <td class=" no_mobile">{{ element.avgPrice | currency }}</td>
          <td>{{ element.subtotal | currency }}</td>
          <td class=" no_mobile">{{ element.fees | currency }}</td>
          <td>
            {{ element.tips | currency }}
          </td>
          <td class=" no_mobile">
            {{ element.tipPercent | percent }}
          </td>
          <td>{{ element.revenue | currency }}</td>
          <td class=" no_mobile">{{ element.redeemedUnits }}</td>
          <td>{{ element.redeemedPercent | percent }}</td>
          <td class=" no_mobile">
            {{ element.revenue / totals.revenue | percent }}
          </td>
        </tr>
      </tbody>
      <tfoot class="body1" *ngIf="data.length">
        <tr class="totals-row">
          <td class="left">TOTAL</td>
          <td>{{ totals.units }}</td>
          <td class=" no_mobile">{{ totals.avgPrice | currency }}</td>
          <td>{{ totals.subtotal | currency }}</td>
          <td class=" no_mobile">{{ totals.fees | currency }}</td>
          <td>{{ totals.tips | currency }}</td>
          <td class=" no_mobile">{{ totals.tipPercent | percent }}</td>
          <td>{{ totals.revenue | currency }}</td>
          <td class=" no_mobile">{{ totals.redeemedUnits }}</td>
          <td class="right-mobile">{{ totals.redeemPercent | percent }}</td>
          <td class="right no_mobile">{{ 1 | percent }}</td>
        </tr>
      </tfoot>
    </table>
  </ng-container>
  <div class="table-empty-state body1 " *ngIf="data.length == 0">
    No Orders Yet!
  </div>
  <ng-template *ngIf="data.length == 0">
    <div class="table-empty-state body1 ">
      No Orders Found!
    </div>
  </ng-template>
</ng-container>
<ng-template #empty>
  <div class="table-empty-state body1 "></div>
</ng-template>
